(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["manual-auto-toc-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = '[data-manual-auto-toc-section]';
    const mobileMediaQuery = window.matchMedia('(max-width: 899px)');

    const slugify = (text, index) => {
      const slug = text
        .trim()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\p{L}\p{N}\s-]/gu, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

      return slug || `section-${index + 1}`;
    };

    const uniqueId = (base, heading) => {
      let id = base;
      let count = 2;

      while (document.getElementById(id) && document.getElementById(id) !== heading) {
        id = `${base}-${count}`;
        count += 1;
      }

      return id;
    };

    const keepActiveLinkVisible = (container, activeLink) => {
      if (!container || !activeLink) {
        return;
      }

      const containerTop = container.scrollTop;
      const containerBottom = containerTop + container.clientHeight;
      const linkTop = activeLink.offsetTop;
      const linkBottom = linkTop + activeLink.offsetHeight;
      const padding = 20;

      if (linkTop < containerTop + padding) {
        container.scrollTop = Math.max(linkTop - padding, 0);
      } else if (linkBottom > containerBottom - padding) {
        container.scrollTop = Math.max(linkBottom - container.clientHeight + padding, 0);
      }
    };

    const setCurrent = (links, activeId, container) => {
      let activeLink = null;

      links.forEach((link) => {
        if (link.getAttribute('href') === `#${activeId}`) {
          link.setAttribute('aria-current', 'true');
          activeLink = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });

      keepActiveLinkVisible(container, activeLink);
    };

    const init = (root) => {
      if (root.dataset.manualAutoTocReady === 'true') {
        return;
      }

      const content = root.querySelector('[data-manual-auto-toc-content]');
      const list = root.querySelector('[data-manual-auto-toc-list]');
      const nav = root.querySelector('.manual-auto-toc__nav');
      const details = root.querySelector('.manual-auto-toc__details');

      if (!content || !list) {
        return;
      }

      const syncDetailsState = () => {
        if (!details) {
          return;
        }

        if (mobileMediaQuery.matches) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }
      };

      const selectors = [];

      if (root.dataset.includeH1 === 'true') {
        selectors.push('h1');
      }

      if (root.dataset.includeH2 === 'true') {
        selectors.push('h2');
      }

      if (root.dataset.includeH3 === 'true') {
        selectors.push('h3');
      }

      if (!selectors.length) {
        root.classList.add('manual-auto-toc--empty');
        syncDetailsState();
        root.dataset.manualAutoTocReady = 'true';
        return;
      }

      const headings = Array.from(content.querySelectorAll(selectors.join(','))).filter((heading) => {
        return heading.textContent.trim() && !heading.hasAttribute('data-manual-auto-toc-skip');
      });

      if (!headings.length) {
        root.classList.add('manual-auto-toc--empty');
        syncDetailsState();
        root.dataset.manualAutoTocReady = 'true';
        return;
      }

      const links = [];
      list.replaceChildren();

      headings.forEach((heading, index) => {
        if (!heading.id) {
          heading.id = uniqueId(slugify(heading.textContent, index), heading);
        }

        const item = document.createElement('li');
        const link = document.createElement('a');
        const level = heading.tagName.toLowerCase();

        item.className = `manual-auto-toc__item manual-auto-toc__item--${level}`;
        link.className = 'manual-auto-toc__link';
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();

        link.addEventListener('click', () => {
          if (details && window.matchMedia('(max-width: 899px)').matches) {
            details.removeAttribute('open');
          }
        });

        item.appendChild(link);
        list.appendChild(item);
        links.push(link);
      });

      setCurrent(links, headings[0].id, nav);

      if ('IntersectionObserver' in window) {
        const visible = new Set();
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                visible.add(entry.target.id);
              } else {
                visible.delete(entry.target.id);
              }
            });

            const active = headings.find((heading) => visible.has(heading.id));

            if (active) {
              setCurrent(links, active.id, nav);
            }
          },
          {
            rootMargin: '-20% 0px -65% 0px',
            threshold: 0.01
          }
        );

        headings.forEach((heading) => observer.observe(heading));
      }

      syncDetailsState();
      if (typeof mobileMediaQuery.addEventListener === 'function') {
        mobileMediaQuery.addEventListener('change', syncDetailsState);
      } else if (typeof mobileMediaQuery.addListener === 'function') {
        mobileMediaQuery.addListener(syncDetailsState);
      }

      root.dataset.manualAutoTocReady = 'true';
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(roots).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
